import { gql } from '@apollo/client'

export const cancelBlogTranscriptionJobMutation = gql`
  mutation cancelBlogTranscriptionJob($input: CancelBlogTranscriptionJobArgs!) {
    cancelBlogTranscriptionJob(input: $input) {
      _id
      transcribingMetadata {
        status
        jobId
        startedAt
        videoCount
      }
      updatedAt
    }
  }
`
